// People card game data with rankings
export const PEOPLE_CARDS = [
  { id: 1, name: "Taylor Swift", rank: 1 , image: "/images/people/people_1.jpg"},
  { id: 2, name: "Bad Bunny", rank: 2 , image: "/images/people/people_2.jpg"},
  { id: 3, name: "Ariana Grande", rank: 3 , image: "/images/people/people_3.jpg"},
  { id: 4, name: "Max Verstappen", rank: 4 , image: "/images/people/people_4.jpg"},
  { id: 5, name: "Drake", rank: 5 , image: "/images/people/people_5.jpg"},
  { id: 6, name: "Lady Gaga", rank: 6 , image: "/images/people/people_6.jpg"},
  { id: 7, name: "Olivia Rodrigo", rank: 7 , image: "/images/people/people_7.jpg"},
  { id: 8, name: "Selena Gomez", rank: 8 , image: "/images/people/people_8.jpg"},
  { id: 9, name: "Lewis Hamilton", rank: 9 , image: "/images/people/people_9.jpg"},
  { id: 10, name: "Cristiano Ronaldo", rank: 10 , image: "/images/people/people_10.jpg"},
  { id: 11, name: "Adele", rank: 11 , image: "/images/people/people_11.jpg"},
  { id: 12, name: "Cardi B", rank: 12 , image: "/images/people/people_12.jpg"},
  { id: 13, name: "Rihanna", rank: 13 , image: "/images/people/people_13.jpg"},
  { id: 14, name: "Justin Bieber", rank: 14 , image: "/images/people/people_14.jpg"},
  { id: 15, name: "Billie Eilish", rank: 15 , image: "/images/people/people_15.jpg"},
  { id: 16, name: "LeBron James", rank: 16 , image: "/images/people/people_16.jpg"},
  { id: 17, name: "Scarlett Johansson", rank: 17 , image: "/images/people/people_17.jpg"},
  { id: 18, name: "Shakira", rank: 18 , image: "/images/people/people_18.jpg"},
  { id: 19, name: "Ed Sheeran", rank: 19 , image: "/images/people/people_19.jpg"},
  { id: 20, name: "Nicki Minaj", rank: 20 , image: "/images/people/people_20.jpg"},
  { id: 21, name: "Kim Kardashian", rank: 21 , image: "/images/people/people_21.jpg"},
  { id: 22, name: "Beyonce", rank: 22 , image: "/images/people/people_22.jpg"},
  { id: 23, name: "Kendrick Lamar", rank: 23 , image: "/images/people/people_23.jpg"},
  { id: 24, name: "Dua Lipa", rank: 24 , image: "/images/people/people_24.jpg"},
  { id: 25, name: "Travis Scott", rank: 25 , image: "/images/people/people_25.jpg"},
  { id: 26, name: "Bruno Mars", rank: 26 , image: "/images/people/people_26.jpg"},
  { id: 27, name: "Will Smith", rank: 27 , image: "/images/people/people_27.jpg"},
  { id: 28, name: "The Weeknd", rank: 28 , image: "/images/people/people_28.jpg"},
  { id: 29, name: "Miley Cyrus", rank: 29 , image: "/images/people/people_29.jpg"},
  { id: 30, name: "Novak Djokovic", rank: 30 , image: "/images/people/people_30.jpg"}
];
